module.exports = __webpack_public_path__ + "static/media/mute_black.4c171b87.svg";